import React from "react";
import AIInsightCard from "@/components/shipment/AIInsightCard";
import { STAT_ACCENT_KEYS } from "./reportTheme";

const ReportStatCard = ({ icon: Icon, label, value, colorIndex = 0 }) => (
    <AIInsightCard
        icon={Icon}
        title={label}
        value={value}
        accentKey={STAT_ACCENT_KEYS[colorIndex % STAT_ACCENT_KEYS.length]}
        variant="compact"
        showTrendIcon={false}
    />
);

export default ReportStatCard;
